import { render, staticRenderFns } from "./QuestionCard.vue?vue&type=template&id=0ca6d6d1&"
import script from "./QuestionCard.vue?vue&type=script&lang=js&"
export * from "./QuestionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports